module.exports = __webpack_public_path__ + "img/590.360d4f12.jpg";